import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Contact from "@/views/Contact.vue";
import SharedRideServices from "@/views/SharedRideServices.vue";
import FixedRouteServices from "@/views/FixedRouteServices.vue";
import TransServicesOverview from "@/views/TransServicesOverview.vue";
import TransProgramOverview from "@/views/TransProgramOverview.vue";
import TransProgramSeniors from "@/views/TransProgramSeniors.vue";
import TransProgramPersonWDis from "@/views/TransProgramPersonWDis.vue";
import TransProgramLowIncomeInd from "@/views/TransProgramLowIncomeInd.vue";
import HowToApply from "@/views/HowToApply.vue";
import HowToScheduleTrip from "@/views/HowToScheduleTrip.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/Home",
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      title: "Home"
    }
  },
  {
    path: "/home/contact",
    name: "contact",
    component: Contact,
    meta: {
      title: "Contact us"
    }
  },
  {
    path: "/home/transportation-services-overview",
    name: "transServicesOverview",
    component: TransServicesOverview,
    meta: {
      title: "Transportation Services Overview"
    }
  },
  {
    path: "/home/transportation-services/shared-ride-services",
    name: "sharedRideServices",
    component: SharedRideServices,
    meta: {
      title: "Shared Ride Services"
    }
  },
  {
    path: "/home/transportation-services/fixed-route-services",
    name: "fixedRouteServices",
    component: FixedRouteServices,
    meta: {
      title: "Fixed Route Services"
    }
  },
  {
    path: "/home/transportation-progams",
    name: "transProgramOverview",
    component: TransProgramOverview,
    meta: {
      title: "Transportation Programs Overview"
    }
  },
  {
    path: "/home/transportation-progams/seniors",
    name: "transProgramSeniors",
    component: TransProgramSeniors,
    meta: {
      title: "Seniors"
    }
  },
  {
    path: "/home/transportation-progams/person-with-disabilities",
    name: "transProgramPersonWDis",
    component: TransProgramPersonWDis,
    meta: {
      title: "Persons with Disabilities"
    }
  },
  {
    path: "/home/transportation-progams/low-income-individuals",
    name: "transProgramLowIncomeInd",
    component: TransProgramLowIncomeInd,
    meta: {
      title: "Low income individuals"
    }
  },
  {
    path: "/home/how-to-apply",
    name: "howToApply",
    component: HowToApply,
    meta: {
      title: "How to apply"
    }
  },
  {
    path: "/home/how-to-schedule-a-trip",
    name: "howToScheduleTrip",
    component: HowToScheduleTrip,
    meta: {
      title: "How to schedule a trip"
    }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, _from, next) => {
  if (to.meta && to.meta.title)
    document.title = `PennDOT Find My Ride Education - ${to.meta.title}`;
  next();
});

export default router;
